export const AffiliateTypeEnum = {
  COMPANY: 'COMPANY',
  PERSON: 'PERSON',
  LEGACY: 'LEGACY',
};
